'use client';
import Accordion from 'react-bootstrap/Accordion';
import { ReactNode } from 'react';
import './accordion.scss';

export interface AccordionItem {
  id: string;
  title: string | ReactNode;
  content: string | ReactNode;
}

export interface AccordionComponentProps {
  items: AccordionItem[];
  defaultActiveKey?: string | string[];
  flush?: boolean;
  alwaysOpen?: boolean;
  className?: string;
}

function AccordionComponent({
  items,
  defaultActiveKey = '0',
  flush = true,
  alwaysOpen = false,
  className,
}: AccordionComponentProps) {
  return (
    <Accordion
      defaultActiveKey={defaultActiveKey}
      flush={flush}
      alwaysOpen={alwaysOpen}
      className={className}
    >
      {items.map((item, index) => (
        <Accordion.Item
          eventKey={item.id || index.toString()}
          key={item.id || index}
        >
          <Accordion.Header>{item.title}</Accordion.Header>
          <Accordion.Body>{item.content}</Accordion.Body>
        </Accordion.Item>
      ))}
    </Accordion>
  );
}

export default AccordionComponent;
